import logStore from '../store/log.js'
import loginStore from '../store/login.js'
import axiosInstances from '../server/axiosInstances'
import querystring from 'querystring'
import { ENGINE_METHOD_PKEY_METHS } from 'constants';
import SimpleTable from '../library/SimpleTable'
import utils from './utils'
import cache from './cache'


/*async function getRemoteAndLocalData(item, eitem, source, cmd, lang) {
  let type = utils.parseField(source, true)
  let args = utils.parseField(source)
  if (args) {
    processSourceArgs(type, args, item, eitem)
  }

  switch (type) {
    case 'array':
      eitem.array = true
      eitem.type = 'array'
      // item.sortable = false
      eitem.arrayTable = cmd.table[0][0]
      item.component = SimpleTable
      // console.log('cmd is: ', cmd)
      var l = store.state.translator.filter(i => i.key === eitem.arrayTable)
      // console.log('array query return', query, l)
      eitem.headerTable = await getTableSchema(l, lang)
      // console.log('headerTable =', eitem.headerTable, l, lang)
      if (eitem.headerTable.headers) eitem.headerTable.headers.sort((a,b) => {
        return a.p - b.p
      })
      if (eitem.headerTable.editables) eitem.headerTable.editables.sort((a,b) => {
        return a.p - b.p
      })
      break
    case 'table':
    // console.log('table processing: ', cmd)
      eitem.objectlist = true
      item.sortable = false
      let table
      let fields = []
      if (cmd.table) {
        table = cmd.table[0][0]
        fields = cmd.table[1]
        item.format = 'filter?' + table + ':' + fields.join()
        eitem.format = item.format
      }
    
      if (cmd.copy) {
        // console.log('copy: ', cmd)
        eitem.copy_from = cmd.copy[0][0]
        eitem.copy_to = cmd.copy[1][0]
        // eitem.copy_from.forEach(i => {
        //   fields.push(i)
        // })
      } 
      let params = {return: fields}
      var query = '/dt/v1/' + table + '?' + querystring.stringify(params)
      var l = await axiosInstances.apiServer.get(query)
      l = l.data
      // console.log('table query return: ',query, l.data)
      // let l = cache.getTable(table)
      if (l) {
        let items = l.map( function(i) {
          // console.log('tttt: ', i, fields)
          // let str = typeof i[fields[0]] === 'object' ? i[fields[0]].qty + ' ' + i[fields[0].unit] : i[fields[0]]
          // i[fields[0]]
          
          // let str = (fields[0] === 'lot' ? fields[0] + '-' : '') + (i[fields[0]] ? i[fields[0]] : '')
          let str = i[fields[0]]
          if (fields && fields.length > 0) {
            // str += ' ('
            var first = true
            fields.forEach((f, indx) => {
              if (indx === 0) {
                // str
              } else {
                if (first) {
                  first = false
                  str += ' ( '
                }
                str += typeof i[f] === 'object' ? i[f].qty + ' ' + i[f].unit : i[f]
                if (!first) {
                  str += ' ) '
                }
              }
            })
            // str = str + ')'
          }
          return {display: str, value: i._id}
        })
      
        items.sort((a,b) => {
          try {
            return a['display'].localeCompare(b['display'])
          } catch(ex) {
            console.log('exception ',a,b,ex)
          }
          
        })
        // items = items.filter((value, index, self) => self.map(x => x.display).indexOf(value.display) == index)
        eitem.listItems = items
      }
      break 
    default: 
      // source is field itself
      if (cmd.copy) {
        eitem.copy_from = cmd.copy[0][0]
        eitem.copy_to = cmd.copy[1][0]
        // console.log('copy: ', eitem)
        // eitem.copy_from.forEach(i => {
        //   fields.push(i)
        // })
      }
      break
  }
}*/

async function processSourceArgs(item, eitem, src, filter, fmt, row) {
  // console.log('processSourceArgs args: ',eitem, /*eitem, src, filter, */src, fmt)
  // if (fmt == undefined) console.log('undefined format for ', item.text)
  if (src.list === undefined && src.table === undefined) return
  if (src.list) {
    eitem.list =true
    eitem.listItems = src.list[0]
  } else if (src.table) {
    let objectlist = []
    let tableName = src.table[0][0]
    let table = await cache.getTable(tableName) 
    if (!table) return
    // console.log('processing sopurce args in table: ', tableName, table, fmt)
    table.forEach(i => {
      if (!fmt || !fmt.filter) {
        console.log('No format information: ', i.name, i, fmt)
        return
      }
      objectlist.push({display: utils.getValueFromID(i._id, fmt.filter[0], fmt.filter[1]), value: i._id})
    })
    if (fmt.action) {
      eitem.objectlist = false
    } else {
      eitem.listItems = objectlist
      eitem.objectlist = true
      if (row.type == 'multiselect') eitem.multiple = true
    }
    // console.log(objectlist)
  }
}

async function getTableSchema(schema, lang, sort) {
  if (!schema) {
    console.log('ERROR: no schema in schema call')
  }
  // logStore.state.elog
  // console.log('#####', 'trace', 'getTableSchema - Template: {}, Lang: {}, Sort: {}', schema, lang, sort)
  // let schemaobject 
  // try {
  //   // store.state.elog('trace', 'Computed Schema: {}, {}', template[0].key, axiosInstances.computeServer)()
  //   schemaobject = await axiosInstances.computeServer.get('/schema?table='+template[0].key)
  //   store.state.elog('trace', 'Computed Schema: {}, {}', template[0].key, schemaobject.data)()
  // } catch(e) {
  //   store.state.elog('trace', 'compute server failure for schema {}', e)()
  // }
  
  // if (!template || template.length ==0) {
  //   return []
  // }
  let headers = []
  let editables = []
  // let order = []
  var idx = 0
  let res = await axiosInstances.loginServer.get('/dt/v1/'+schema)
  // console.log('#####', res)
  if (res == null || res.data == null) {
    // logStore.state.elog
    console.log('error', 'Schema {} is not found', schema)
    return []
  }
  let schemaTable = res.data

  await Promise.all(schemaTable.map(async function(row) {
    if (!row) return
    // console.log(row)
    let item = {}
    // if (row.key === '_fields') {
    //   console.log(row.filter)
    //   item.show = false
    //   item._exclude = row.filter.split(',')
    //   console.log('fields**= ', item)
    //   return
    // }
    let eitem = {}
    // first get the header/title of tyhe fields
    item.text = utils.parseField(row[lang], true) // just get the display field only
    eitem.header = item.text
    //now fill in values common to all items
    item.align = row.align || 'left' // if not specified, left align
    item.value = row.key
    item.p = row.pos
    item.show = row.show == 'no' ? false : true
    // the following fields are only used in edit dialog
    eitem.readonly = row.ro == 'yes' || (row._fields && row._fields.includes(item.text)) ? true : false // default is writeable
    eitem.p = row.pos
    eitem.name = row.key
    
    // the arguments that follow the english title tell us where to get the source data
    // the types of source data include:
    // table - anothet table will provide data
    // list - a list of items is attached
    // local - default if nothing is specified, just take the entry as it is
    let cmd = utils.parseField(row['en'])
    if (typeof cmd !== 'object') {
      cmd = {self: []}
    }
    // the filter field is used to filter the source list, not currently used
    let filter = utils.parseField(row.filter)
    let src = cmd

    // for now parse these fields from 'type' field
    // TBD get rid of type field and use format field directly
    if (row.type === 'date') {
      if (!row.format) item.format = 'type:self;filter:date'
      eitem.datetimepicker = true
    } else if (row.type === 'remote') {
      eitem.remote = true
    } else if (row.type === 'code') {
      eitem.code = true
    } else if (row.type === 'fileDND') {
      // console.log('command is: ', cmd)
      eitem.dir = cmd.dir && cmd.dir[0] && cmd.dir[0][0] ? cmd.dir[0][0] : null
      eitem.fileDND = true
      item.format = row.format
      // item.format = 'type:self;filter:string'
    } else if (row.type === 'currency') {
      if (!row.format) item.format = 'type:self;filter:currency'
    } else if (row.type === 'textarea') {
      // item.format = 'type:self;filter:string'
      eitem.textarea = true
    } else if (row.type === 'measure') {
      if (!row.format) item.format = 'type:self;filter:measure' 
      item.sortable = false
      eitem.measure = true
      eitem.value = {quantity: 'qty', unit: 'unit'}, 
      eitem.itemHeader = {quantity: 'Quantity', unit: 'Unit'},  
      eitem.units = ['g', 'kg', 'oz', 'lb', 'units', 'packages', 'ml', 'l', 'fl oz', 'gal']
    } else if (row.type === 'list') {
      var x = utils.parseField(row.format)
      if (x && x.filter && x.filter[0] == 'status') {
        item.component = 'status'
      } else if (x && x.filter && x.filter[0] == 'gaugearray') {
        item.component = 'circulargauge'
      } else if (x && x.filter && x.filter[0] == 'document') {
        item.component = 'document'
      }
      item.format = 'type:self;filter:list'
    }  else if (row.type === 'multilist') {
      item.format = 'type:self;filter:list'
      eitem.multiple = true
    } else if (row.type === 'status') {
      item.component = 'status'
    } else if (row.type === 'gaugearray') {
      item.component = 'circulargauge'
    } else if (row.type === 'document') {
      item.component = 'document'
    } else if (row.type === 'function') {
      // return
      let f = {}
      try {
        f = JSON.parse(row.filter)
      } catch (ex) {
        console.log(ex)
      }
      console.log(f)
      eitem.list = true
      eitem.multiple = true
      let server = f.server == 'auth' ? axiosInstances.authServer : axiosInstances.apiServer
      let pipe = f.pipe
      let table = f.table
      let ur, resP
      try {
        ur = "/misc/dbops?c=" + table + "&op=pipe";
        resP = await server.post(ur, pipe);
        resP = resP.data == null ? [] : resP.data
      } catch (ex) {
        console.log('Line 286 error', ex)
      }
      // var f = row.filter
      console.log(pipe, resP)
      eitem.listItems = ['a', 'b']
      item.format = 'type:self;filter:list'
    }
    
    if (row.type === 'array') {
      eitem.objectlist = false
      eitem.array = true
      eitem.type = 'array'
      eitem.arrayTable = cmd.table && cmd.table[0] ? cmd.table[0][0] : []
      item.component = SimpleTable
      // var l = store.state.translator.filter(i => i.key === eitem.arrayTable)
      if (!eitem.arrayTable) {
        console.log('no array table in eitem: ', eitem)
      }
      eitem.headerTable = await getTableSchema(eitem.arrayTable, lang, false)
    }
    // if (row.type === 'vararray') {
    //   eitem.objectlist = false
    //   eitem.vararray = true
    //   eitem.type = 'vararray'
    //   // eitem.arrayTable = cmd.fields[0][0]
    //   // item.component = SimpleTable
    // }
    if (!item.format) item.format = row.format

    // else if anything is not yet defined assume string
    if (item.format === undefined || item.format === '') item.format = 'type:self;filter:string'
    eitem.format = item.format
    // now parse the format string. 
    // If not specified assume string
    let fmt = utils.parseField(item.format)

    // now build up the list to choose from in case the item is a list or object list
    // if it is a table, the display names will be generated recursively searvhing each table
    await processSourceArgs(item, eitem, src, filter, fmt, row)

    if (loginStore.state.loggedinUser.role == 'admin' || loginStore.state.loggedinUser.role == 'super') {
      if (row.key == 'cts' ) {
        eitem.name = 'octs'
        eitem.datetimepicker = true
        editables.push(eitem)
      }
    } 

    if (row.key != 'ts' && row.key != 'cts' ) {
      editables.push(eitem)
    }
    // if (item.show) 
    // headers['show'] = item.show
    headers[idx++] = item
  }))
  headers.sort((a,b) => { return a.p - b.p})
  editables.sort((a,b) => { return a.p - b.p})
  // logStore.elog.state('trace', 'headers: {}, editables: {}', headers, editables)()
  // console.log('@@@@@@@@', headers, editables)
  return {headers, editables}
}

// following function is defined async as it will eventually fetch a mapping table from server
// async function tableMappings(name) {
//   var t = await axiosInstances.authServer.get('/dt/v1/translator')
//   if (!t || !t.data) return ''
//   t = t.data
//   let match = t.filter(i => i.key == name)
//   if (t.length == 0) return ''
//   return match[0]
// }

// async function fetchTable (tableName, org) {
//   let mappedTableObject = await tableMappings(tableName)
//   let server = axiosInstances.apiServer
//   if (org == 'auth') server = axiosInstances.authServer
//   let table = await server.get('/dt/v1/translator?key=' + mappedTableObject.key)
//   return table.data
// }

async function getPrinterDef (tableName) {
  let res = await cache.getTable('set_scanners')
  //axiosInstances.apiServer.get('/dt/v1/set_scanners')
  let printerTable = res.data
  if (!printerTable) return []
  let printerObj = printerTable.filter(i => i.table == tableName && i.field == 'id:prt')
  return printerObj && printerObj.length > 0 ? printerObj : []
}

async function getInputDevices (tableName) {
  let res = await cache.getTable('set_scanners')
  //axiosInstances.apiServer.get('/dt/v1/set_scanners')
  let devTable = res.data
  if (!devTable) return []
  let devObj = devTable.filter(i => i.table == tableName && (i.type == 'rfid' || i.type == 'scale'))
  return devObj && devObj.length > 0 ? devObj : []
}

async function getMorePrinter (tableName) {
  let res = await cache.getTable('set_scanners')
  // axiosInstances.apiServer.get('/dt/v1/set_scanners')
  let printerTable = res.data
  if (!printerTable) return []
  let printerObj = printerTable.filter(i => i.table == tableName && i.field == 'id:more')
  return printerObj.length > 0 ? printerObj : []
}

const preprocessUtils = {
  getTableSchema,
  // fetchTable,
  // tableMappings,
  getPrinterDef,
  getInputDevices,
  getMorePrinter
}

export default preprocessUtils
